import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=2c06577e&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"
import style0 from "./AllNews.vue?vue&type=style&index=0&id=2c06577e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06577e",
  null
  
)

export default component.exports